import React, {useState, useEffect, useRef, useContext} from "react";
import {useHistory, useParams} from 'react-router-dom'
import * as Yup from "yup";
import {MultiSelect} from "primereact/multiselect";
import {TranslateContext} from "../../context/TranslateContext";
import {ParametersContext} from "../../context/ParametersContext";
import NsField from "../../components/fields/NsField.jsx";
import {aggiornaParametroApi, getParametroByIdApi} from "./services/ParametriServices";
import ModificaImpostazioneView from "./ModificaImpostazioneView";
import { Field } from "formik";

export default function ModificaImpostazioneController() {
    const {id} = useParams()

    const [parametro, setParametro] = useState();
    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [selectedMultiSelect, setSelectedMultiSelect] = useState(null);

    const {translate} = useContext(TranslateContext);
    const {resetParameters} = useContext(ParametersContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getData() {
        const response = await getParametroByIdApi(id);
        setLoadingData(false);
        let param = response.data.data;
        setParametro(param)

        if (formikRef.current) {
            formikRef.current.setFieldValue("id", param.id)
            formikRef.current.setFieldValue("codice", param.codice)
            formikRef.current.setFieldValue("descrizione", param.descrizione)
            formikRef.current.setFieldValue("valore", param.valore)
            
            if (param.tipo === 'EM') {
                let valori = param.valore ? param.valore.split('#|#') : ''
                formikRef.current.setFieldValue("oggetto", (valori.length > 0 ? valori[0] : ''));
                formikRef.current.setFieldValue("valore", (valori.length > 1 ? valori[1] : ''));
            } else if (param.tipo === 'MS') {
                setSelectedMultiSelect(param.valore.split(','));
            }
        }
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getData();
            }
        }
    }, []);

    const SignupSchema = Yup.object().shape({
        valore: Yup.string()
            .max(500, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
    });

    const getValore = (values, errors, touched, submitCount) => {
        if (parametro.tipo === 'T') {
            return <NsField
                name={"valore"}
                formikRef={formikRef}
                values={values}
                errors={errors}
                touched={touched}
                submitCount={submitCount}
            />
        } else if (parametro.tipo === 'N') {
            return <NsField
                name={"valore"}
                as={"number"}
                formikRef={formikRef}
                values={values}
                errors={errors}
                touched={touched}
                submitCount={submitCount}
            />
        } else if (parametro.tipo === 'L') {
            var valori = parametro.valori_previsti.split(';')

            return <NsField
                name={"valore"}
                as={"select"}
                options={() => {
                    let opts = valori.map((val, idx) => {
                        var chiaveValore = val.split('=')
                        return {
                            label: chiaveValore[1],
                            value: chiaveValore[0],
                        };
                    })
                    return opts;
                }}
                formikRef={formikRef}
                values={values}
                errors={errors}
                touched={touched}
                submitCount={submitCount}
            />
        } else if (parametro.tipo === 'B') {
            return <NsField
                name={"valore"}
                as={"select"}
                options={[
                    {
                        label: "Sì",
                        value: "1"
                    },
                    {
                        label: "No",
                        value: "0"
                    },
                ]}
                formikRef={formikRef}
                values={values}
                errors={errors}
                touched={touched}
                submitCount={submitCount}
            />
        } else if (parametro.tipo === 'TA') {
            return <NsField
                name={"valore"}
                as={"textarea"}
                formikRef={formikRef}
                values={values}
                errors={errors}
                touched={touched}
                submitCount={submitCount}
            />
        } else if (parametro.tipo === 'MS') {
           var valori = parametro.valori_previsti.split(';');
            return <NsField
            name={"valore"}
            as={"multiselect"}
            options={valori.map((val, idx) => {
                var chiaveValore = val.split('=')
                return {
                    label: chiaveValore[1],
                    value: chiaveValore[0],
                };
            })}
            formikRef={formikRef}
            values={values}
            errors={errors}
            touched={touched}
            submitCount={submitCount}
        />
        } else {
            return ''
        }
    }

    async function aggiornaParametro(values) {
        const response = await aggiornaParametroApi(id, values);
        if (response.data.result === 0) {
            history.push("/conf-parametri");
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
        resetParameters();
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    return (
        <ModificaImpostazioneView
            show={show}
            formikRef={formikRef}
            setShow={setShow}
            SignupSchema={SignupSchema}
            translate={translate}
            modalMsg={modalMsg}
            aggiornaParametro={aggiornaParametro}
            getValore={getValore}
            parametro={parametro}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        />
    );
}